import { buildUserOperation } from "../../actions/smartAccount/buildUserOperation.js";
import { buildUserOperationFromTx } from "../../actions/smartAccount/buildUserOperationFromTx.js";
import { buildUserOperationFromTxs } from "../../actions/smartAccount/buildUserOperationFromTxs.js";
import { checkGasSponsorshipEligibility } from "../../actions/smartAccount/checkGasSponsorshipEligibility.js";
import { dropAndReplaceUserOperation } from "../../actions/smartAccount/dropAndReplaceUserOperation.js";
import { getAddress } from "../../actions/smartAccount/getAddress.js";
import { sendTransaction } from "../../actions/smartAccount/sendTransaction.js";
import { sendTransactions } from "../../actions/smartAccount/sendTransactions.js";
import { sendUserOperation } from "../../actions/smartAccount/sendUserOperation.js";
import { signMessage, } from "../../actions/smartAccount/signMessage.js";
import { signMessageWith6492 } from "../../actions/smartAccount/signMessageWith6492.js";
import { signTypedData, } from "../../actions/smartAccount/signTypedData.js";
import { signTypedDataWith6492 } from "../../actions/smartAccount/signTypedDataWith6492.js";
import { signUserOperation } from "../../actions/smartAccount/signUserOperation.js";
import { upgradeAccount } from "../../actions/smartAccount/upgradeAccount.js";
import { waitForUserOperationTransaction } from "../../actions/smartAccount/waitForUserOperationTransacation.js";
export const smartAccountClientActions = (client) => ({
    buildUserOperation: (args) => buildUserOperation(client, args),
    buildUserOperationFromTx: (args, overrides) => buildUserOperationFromTx(client, args, overrides),
    buildUserOperationFromTxs: (args) => buildUserOperationFromTxs(client, args),
    checkGasSponsorshipEligibility: (args) => checkGasSponsorshipEligibility(client, args),
    signUserOperation: (args) => signUserOperation(client, args),
    dropAndReplaceUserOperation: (args) => dropAndReplaceUserOperation(client, args),
    sendTransaction: (args, overrides) => sendTransaction(client, args, overrides),
    sendTransactions: (args) => sendTransactions(client, args),
    sendUserOperation: (args) => sendUserOperation(client, args),
    waitForUserOperationTransaction: (args) => waitForUserOperationTransaction.bind(client)(client, args),
    upgradeAccount: (args) => upgradeAccount(client, args),
    getAddress: (args) => getAddress(client, args),
    signMessage: (args) => signMessage(client, args),
    signTypedData: (args) => signTypedData(client, args),
    signMessageWith6492: (args) => signMessageWith6492(client, args),
    signTypedDataWith6492: (args) => signTypedDataWith6492(client, args),
});
export const smartAccountClientMethodKeys = Object.keys(smartAccountClientActions(undefined)).reduce((accum, curr) => {
    accum.add(curr);
    return accum;
}, new Set());
//# sourceMappingURL=smartAccountClient.js.map